import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { logout } from './authSlice';
import api from './config';

const initialState = {
  items: [],
  total: 0,
  loading: false,
  errors: []
};

// GET /moyasar/transactions — paiements par carte (Moyasar), plus récents d'abord, paginés côté
// serveur (page commence à 1, limit ≤ 100). Réservé SUPER_ADMIN côté backend (ou assistant avec
// la permission entreprises.validerAbonnement), voir moyasar.controller.ts.
export const fetchCardPayments = createAsyncThunk(
  'cardPayments/fetchCardPayments',
  async (params = {}, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.get('/moyasar/transactions', { params });
      return response.data;
    } catch (error) {
      if (!error.response) throw error;
      if (error.response.status === 401) dispatch(logout());
      return rejectWithValue({ message: error.response.data?.message });
    }
  }
);

const cardPaymentsSlice = createSlice({
  name: 'cardPayments',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCardPayments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCardPayments.fulfilled, (state, { payload }) => {
        state.items = payload?.items || [];
        state.total = payload?.total || 0;
        state.errors = [];
        state.loading = false;
      })
      .addCase(fetchCardPayments.rejected, (state, { payload }) => {
        state.items = [];
        state.total = 0;
        state.errors = payload?.message ? [payload.message] : ['error'];
        state.loading = false;
      });
  }
});

export default cardPaymentsSlice.reducer;
